import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { Link } from 'react-router-dom';
import { Checkbox } from "components/__new/common/form";
import SettingsTab from 'components/__new/settings/tab';
import TabSettings from "components/__new/common/TabSettings";
import { ReactComponent as IconAngleLeft } from "assets/images/icons/project-icons/angle-left.svg";
import { Disclosure } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const Form = () => {

    return ( 
        <div>


            <DynamicHeadTag
                headerText="Custom Role | Team Management | Settings"
                headerDescription="Customize your account preferences, including account information, security and privacy settings, notifications, and other account-related options."
            />


            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title">
                        Settings
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-2 lg:mt-0 lg:justify-end space-x-3"></div>
            </div>


            <div className="mt-6 border-b">
                <SettingsTab />
            </div>


            <div className="mt-6 lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title flex">
                        <Link to="/settings/team-management/roles" className="h-8 pr-2 mr-1 flex cursor-pointer">
                            <IconAngleLeft style={{ height: "16px" }} className="w-8 m-auto" />
                        </Link>
                        Create Custom Role
                    </div>
                </div>
                <div className="w-full lg:w-1/2 flex mt-2 lg:mt-0 lg:justify-end space-x-3">
                    {/* 
                    <button type="submit" className="btn btn-ep-primary md:btn-lg">
                        Create custom role
                    </button>
                     */}
                    <Link to="/settings/team-management/roles" className="btn btn-ep-primary md:btn-lg">
                        Create custom role
                    </Link>
                    <Link to="/settings/team-management/roles" className="btn btn-transparent-primary md:btn-lg">
                        Cancel
                    </Link>
                </div>
            </div>


            <div className="mt-6 box">
                <div className="border-b">
                    <TabSettings options={[
                        {
                            title: <span>Role Details</span>,
                            type: "link",
                            url: "/settings/team-management/roles/create/details",
                        },
                        {
                            title: <span>Role Permissons</span>,
                            type: "link",
                            url: "/settings/team-management/roles/create/permissions",
                        },
                    ]} />
                </div>

                <div className="mt-6">
                    
                    <div>
                        Permission Modules
                    </div>

                    <div className="mt-3">
                        {[...Array(6)]?.map((user, index) =>
                            <Disclosure defaultOpen as="div" key={index} className="box p-0 mb-4 border">
                                {({ open }) => (
                                    <>
                                        <Disclosure.Button as="div" className="px-10 py-6 text-ep-primary-600 font-medium flex items-center justify-between cursor-pointer">
                                            Wallet and Bill payment
                                            <FontAwesomeIcon icon={open ? 'minus' : 'plus'} />
                                        </Disclosure.Button>

                                        <Disclosure.Panel as="div" className="px-5">
                                            <div className="px-5 py-8 text-gray-500 border-t border-gray-200">
                                                
                                                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
                                                    {[...Array(6)]?.map((user, index) =>
                                                        <div  key={index}>
                                                            <Checkbox
                                                                type="checkbox"
                                                                label="Initiate Transactions"
                                                            />
                                                        </div>
                                                    )}
                                                </div>

                                            </div>
                                        </Disclosure.Panel>
                                    </>
                                )}
                            </Disclosure>
                        )}
                    </div>


                    <div className="h-10"></div>


                </div>
            </div>




        </div>
    )
}


export default Form;